export const initialState = {
    selected: null,
    data: [],
    pageNum: 1,
    pageSize: 20,
    hasNext: true,
    total: 0,
    loading: false
}

export const reducer = (state, { type, payload, extra }) => {
    const { rowKey = 'id' } = extra || {}

    switch (type) {
        case 'UPDATE':
            return {
                ...state,
                ...payload
            }
        case 'UPDATE_ITEM':
            return {
                ...state,
                data: state.data.map(v => {
                    if (v[rowKey] === payload[rowKey]) {
                        return {
                            ...v,
                            ...payload
                        }
                    }

                    return v
                })
            }
        case 'DELETE_ITEM': {
            let data
            let total

            if (Array.isArray(payload)) {
                data = state.data.filter(v => !payload.some(v1 => v1[rowKey] === v[rowKey]))
                total = state.total - payload.length
            } else {
                data = state.data.filter(v => v[rowKey] !== payload[rowKey])
                total = state.total - 1
            }

            return {
                ...state,
                data,
                total
            }
        }
        case 'RESET':
            return initialState
        default:
            return state
    }
}
